import styles from './CardBook.module.css';

export default function CardBook({ titulo, autor, genero, capa, preco }) {
  return (
    <div className={styles.container}>
      <img src={capa} alt="Capa do livro" />
      <div className={styles.description}>
        <h3>{titulo}</h3>
        <p>{autor}</p>
        <p>{genero}</p>
        <p className={styles.preco}>R${preco}</p>
      </div>
    </div>
  )
}